import { Directive, OnDestroy, inject } from '@angular/core';
import {DataService} from "../../../../services/data.service";
import {FieldsService} from "../../../../services/fields.service";
import {AppState} from "../../../../store";
import {Store} from "@ngrx/store";
import {Subscription} from "rxjs";
import {NotificationService} from "../../../../services/notification.service";

@Directive()
export class BaseComponent implements OnDestroy{
  dataService = inject(DataService);
  fieldsService = inject(FieldsService);
  notificationService = inject(NotificationService);

  store = inject(Store<AppState>);

  subscriptions = new Subscription();

  hasCommonFieldValue(obj1, obj2, fields:string[]) {
    for (const field of fields) {
      if (obj1?.[field] === obj2?.[field]) {
        return true;
      }
    }
    return false;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
